import AltoleapAccountsUI from '@vue-altoleap-libraries/vue-altoleap-accounts-ui';
import AltoleapAccountsLib from '@vue-altoleap-libraries/vue-altoleap-accounts-lib';
import { VueConstructor } from 'vue/types/umd';
import { Store } from 'vuex/types/index';

export function installAltoleap(Vue: VueConstructor, store: Store<any>) {
  Vue.use(AltoleapAccountsUI, {
    data: {
      enableModifyAdminGroup: false,
      showOrganization: false,
      disableRegistration: true,
      setInitialPassword: false,

      config: {
        companyName: 'Jamesway',
        logo: require('@/assets/logos/jamesway_logo.png'),
        logoHeight: 80
      },

      routes: {
        privacyRoute: { name: 'privacy' },
        termsRoute: null
      }
    },

    computed: {
      authProvider() {
        return AltoleapAccountsLib.authProvider(store);
      },

      accountsProvider() {
        return AltoleapAccountsLib.accountsProvider(store);
      },

      groupsProvider() {
        return AltoleapAccountsLib.groupsProvider(store);
      }
    }
  });
}
